export default {"src":"/_next/static/media/kiosk-ticket.0f9785a9.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};